module.exports = __webpack_public_path__ + "static/img/til25.9ff2f45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til25.png
// module id = AUc8
// module chunks = 1